import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from 'theme-ui'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'
import { NewsBoxStylesProps } from './types'

const NewsBoxMediaStyled = styled.div<WithTheme>`
  display: flex;
  background: ${({ theme }) => theme.colors.black};
  border-radius: 0.625rem;
  margin-bottom: 1.125rem;
  height: 7.1875rem;
  overflow: hidden;

  .lazy-load-image-background {
    width: 100%;

    img {
      /* width: 100%; */
      height: auto;
      max-width: 100%;
      /* max-height: 100%; */
    }
  }

  @media ${media.tablet} {
    height: 19.375rem;
    margin-bottom: 1.875rem;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`

const NewsBoxContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 31.875rem;
  white-space: pre-wrap;
`

const NewsBoxContentDateStyled = styled(Text)<WithTheme>`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray3};
  line-height: 1;
  margin-bottom: 0.875rem;
  @media ${media.tablet} {
    font-size: 1.125rem;
    margin-bottom: 1.25rem;
  }
`

const NewsBoxContentCategoryStyled = styled(Text)<WithTheme>`
  margin-bottom: 0.625rem;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.green};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1;
  text-transform: capitalize;
  @media ${media.tablet} {
    font-size: 1.25rem;
    margin-bottom: 0.875rem;
  }
`

const NewsBoxContentTitleStyled = styled(Text)<WithTheme>`
  font-size: 0.875rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.6;
  @media ${media.tablet} {
    font-size: 1.5rem;
    line-height: 1.4;
  }
`

const NewsBoxStyled = styled.div<WithTheme<NewsBoxStylesProps>>`
  display: flex;
  flex-direction: column;
  border-radius: 1.25rem;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0rem 0rem 0.625rem rgba(0, 0, 0, 0.15);
  width: 100%;
  padding: 0.875rem 0.625rem 1.375rem;

  @media ${media.tablet} {
    padding: 1.375rem 1.375rem 3.125rem;
  }

  ${({ isSmall, theme }) =>
    isSmall &&
    css`
      @media ${media.tablet} {
        flex-direction: row;
        padding: 1.5625rem 3.625rem 1.5625rem 1.25rem;
        ${NewsBoxContentStyled} {
          max-width: 18.25rem;
        }
        ${NewsBoxMediaStyled} {
          height: 7.1875rem;
          width: 12.3125rem;
          margin-bottom: 0;
          margin-right: ${theme.direction === 'rtl' ? '0' : '2rem'};
          margin-left: ${theme.direction === 'rtl' ? '2rem' : '0'};
        }
        ${NewsBoxContentDateStyled} {
          font-size: 0.8125rem;
          margin-top: 0.125rem;
        }
        ${NewsBoxContentCategoryStyled} {
          font-size: 0.9375rem;
          margin-bottom: 0.625rem;
        }
        ${NewsBoxContentTitleStyled} {
          font-size: 1.125rem;
          line-height: 1.2;
        }
      }
    `};
`

export {
  NewsBoxStyled,
  NewsBoxMediaStyled,
  NewsBoxContentStyled,
  NewsBoxContentDateStyled,
  NewsBoxContentCategoryStyled,
  NewsBoxContentTitleStyled
}
